import * as http from 'utils/http';
import config from 'config';

const getVehicleDocuments = async (vehicleId) =>
  await http.get(`${config.BASE_URL}/api/dms/documents/vehicle/${vehicleId}/`);

export { getVehicleDocuments };
